import { gql } from '@apollo/client';
const UPDATE_TENANT_TEMPLATE = gql `
  mutation UpdateTenantTemplate($templateId: ID!, $name: String!) {
    updateModelSpecificationTemplate(templateId: $templateId, name: $name) {
      modelSpecificationTemplate {
        id
        name
      }
    }
  }
`;
export default UPDATE_TENANT_TEMPLATE;
